/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="m13.5 21 .0082.2239C13.6228 22.7762 14.9185 24 16.5 24H20l.2239-.0082C21.7762 23.8772 23 22.5815 23 21v-6l-.0082-.2239C22.8772 13.2238 21.5815 12 20 12h-3.5l-.2239.0082C14.7238 12.1228 13.5 13.4185 13.5 15v6Zm0-13.5.0082.2239C13.6228 9.2762 14.9185 10.5 16.5 10.5H20l.2239-.0082C21.7762 10.3772 23 9.0815 23 7.5V3l-.0082-.2239C22.8772 1.2238 21.5815 0 20 0h-3.5l-.2239.0082C14.7238.1228 13.5 1.4185 13.5 3v4.5Zm2.8636-5.994C15.5998 1.5741 15 2.2177 15 3v4.4724l.006.164C15.0741 8.4002 15.7177 9 16.5 9h3.4724l.164-.006C20.9002 8.9259 21.5 8.2823 21.5 7.5V3.0275l-.006-.1639C21.4259 2.0998 20.7823 1.5 20 1.5h-3.4724l-.164.006ZM12 3l-.0082-.2239C11.8772 1.2238 10.5815 0 9 0H4l-.2239.0082C2.2238.1228 1 1.4185 1 3v7.5l.0082.2239C1.1227 12.2762 2.4185 13.5 4 13.5h5l.2239-.0082C10.7762 13.3772 12 12.0815 12 10.5V3Zm0 15-.0082-.2239C11.8772 16.2238 10.5815 15 9 15H4l-.2239.0082C2.2238 15.1228 1 16.4185 1 18v3l.0082.2239C1.1227 22.7762 2.4185 24 4 24h5l.2239-.0082C10.7762 23.8772 12 22.5815 12 21v-3Zm-2.8636 4.494C9.9002 22.4259 10.5 21.7823 10.5 21v-2.9724l-.006-.164C10.4259 17.0998 9.7823 16.5 9 16.5H4.0275l-.1639.006C3.0998 16.5741 2.5 17.2177 2.5 18v2.9724l.006.164C2.5741 21.9002 3.2177 22.5 4 22.5h4.9725l.1639-.006Z"
    clipRule="evenodd"
  />,
  'MenuOverviewFilled'
);
